import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import heritzTailerData from '../data/heritzTailerData.json';
import heritzTailorCounts from '../data/heritzTailorCounts.json';
const reviewPhotos = heritzTailerData.map(v => {
  return {
    id: v.cafeArticleImageShopId,
    src: v.imageUrlW720,
    label: v.shopImageCategoryName,
    category: v.shopImageCategoryName
  }
})
const categories = heritzTailorCounts.map((cat) => {
  return {
    categoryName: cat.shopImageCategoryName,
    count: cat.imageCount
  };
});
export default function PhotosPage({
  
}) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const photoId = searchParams.get('photo');

  const [activeCategory, setActiveCategory] = useState('전체');
  const [selectedPhoto, setSelectedPhoto] = useState<typeof reviewPhotos[0] | null>(null);

  const filtered = activeCategory === '전체'
    ? reviewPhotos
    : reviewPhotos.filter((p) => p.category === activeCategory);

  useEffect(() => {
    if (photoId) {
      const found = reviewPhotos.find((p) => p.id === photoId);
      if (found) setSelectedPhoto(found);
    } else {
      setSelectedPhoto(null);
    }
  }, [photoId]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openPhoto = useCallback((photo: typeof reviewPhotos[0]) => {
    setSearchParams({ photo: photo.id }, { replace: true });
  }, [setSearchParams]);

  const closePhoto = useCallback(() => {
    setSearchParams({});
  }, [setSearchParams]);

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  
  console.log(categories)
  return (
    <div className="min-h-[100dvh] bg-[#F7F2EA]">
      {/* Mobile Header */}
      <div className="lg:hidden sticky top-0 z-40 bg-white border-b border-[#E8E2DA]">
        <div className="flex items-center justify-between h-14 px-4">
          <button onClick={goBack} className="flex items-center justify-center w-8 h-8 -ml-1">
            <i className="ri-arrow-left-s-line text-xl text-[#121B35]" />
          </button>
          <h1 className="text-[15px] font-semibold text-[#121B35]">헤리츠테일러 후기 사진</h1>
          <button className="flex items-center justify-center w-8 h-8">
            <i className="ri-share-line text-lg text-[#121B35]" />
          </button>
        </div>
      </div>

      {/* Desktop Header */}
      <div className="hidden lg:block sticky top-0 z-40 bg-white border-b border-[#E8E2DA]">
        <div className="max-w-[1280px] mx-auto px-6 flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <button
              onClick={goBack}
              className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-[#F7F2EA] transition-colors"
            >
              <i className="ri-close-line text-xl text-[#121B35]" />
            </button>
            <h1 className="text-[17px] font-semibold text-[#121B35]">헤리츠테일러 후기 사진</h1>
          </div>
          <button className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-[#F7F2EA] transition-colors">
            <i className="ri-share-line text-lg text-[#121B35]" />
          </button>
        </div>
      </div>

      {/* Filter — sticky below header */}
      <div className="sticky top-14 lg:top-16 z-30 bg-[#F7F2EA] border-b border-[#E8E2DA]">
        <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-3">
          <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
            {categories.map((cat) => (
              <button
                key={cat.categoryName}
                onClick={() => setActiveCategory(cat.categoryName)}
                className={`shrink-0 px-3 py-1.5 rounded-full text-[12px] font-medium whitespace-nowrap transition-colors ${
                  activeCategory === cat.categoryName
                    ? 'bg-[#121B35] text-white'
                    : 'bg-white text-[#536079] border border-[#E8E2DA]'
                }`}
              >
                {cat.categoryName}
                <span className={`ml-1 ${activeCategory === cat.categoryName ? 'text-[#B9965B]' : 'text-[#9AA3B2]'}`}>
                  {cat.count}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Photo Grid */}
      <div className="max-w-[1280px] mx-auto px-4 lg:px-6 py-4">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1.5">
          {filtered.map((photo) => (
            <div
              key={photo.id}
              className="relative aspect-square rounded-lg overflow-hidden cursor-pointer bg-[#E8E2DA]"
              onClick={() => openPhoto(photo)}
            >
              <img
                src={photo.src}
                alt={photo.label}
                className="w-full h-full object-cover"
              />
              <span className="absolute bottom-1 left-1 bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded">
                {photo.label}
              </span>
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-20 text-[13px] text-[#536079]">
            이 카테고리에 해당하는 사진이 없습니다.
          </div>
        )}
      </div>

      {/* Mobile Detail Overlay */}
      {selectedPhoto && (
        <div className="lg:hidden fixed inset-0 z-50 bg-white flex flex-col">
          {/* Mobile detail header */}
          <div className="flex items-center justify-between h-14 px-4 border-b border-[#E8E2DA] shrink-0">
            <button onClick={closePhoto} className="flex items-center justify-center w-8 h-8 -ml-1">
              <i className="ri-arrow-left-s-line text-xl text-[#121B35]" />
            </button>
            <span className="text-[13px] text-[#536079]">{selectedPhoto.label}</span>
            <button className="flex items-center justify-center w-8 h-8">
              <i className="ri-share-line text-lg text-[#121B35]" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto">
            {/* Main image */}
            <div className="w-full aspect-[3/4] bg-[#E8E2DA]">
              <img
                src={selectedPhoto.src}
                alt={selectedPhoto.label}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Related photos horizontal */}
            {selectedPhoto.relatedPhotos.length > 0 && (
              <div className="px-4 py-4">
                <p className="text-[11px] font-medium text-[#536079] mb-2">같은 게시글의 사진</p>
                <div className="flex gap-2 overflow-x-auto scrollbar-hide">
                  {selectedPhoto.relatedPhotos.map((src, i) => (
                    <div key={i} className="shrink-0 w-20 h-20 rounded-lg overflow-hidden bg-[#E8E2DA]">
                      <img src={src} alt="" className="w-full h-full object-cover" />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Info */}
            <div className="px-4 py-4 border-t border-[#E8E2DA]">
              <div className="flex items-center gap-2 mb-3">
                <span className="bg-[#F7F2EA] text-[#121B35] text-[11px] px-2.5 py-1 rounded-full font-medium">
                  {selectedPhoto.category}
                </span>
                <span className="text-[11px] text-[#9AA3B2]">{selectedPhoto.reviewDate}</span>
              </div>

              <h3 className="text-[14px] font-semibold text-[#121B35] mb-1">
                {selectedPhoto.reviewTitle}
              </h3>
              <p className="text-[13px] text-[#536079] leading-[1.7] mb-3">
                {selectedPhoto.description}
              </p>

              <div className="bg-[#F7F2EA] rounded-xl p-3 mb-3">
                <p className="text-[12px] text-[#121B35] leading-[1.7]">
                  {selectedPhoto.reviewSummary}
                </p>
              </div>

              <div className="flex flex-wrap gap-1.5 mb-4">
                {selectedPhoto.keywords.map((kw) => (
                  <span
                    key={kw}
                    className="text-[11px] text-[#536079] bg-white border border-[#E8E2DA] px-2 py-0.5 rounded-full"
                  >
                    {kw}
                  </span>
                ))}
              </div>

              <a
                href={selectedPhoto.originalUrl}
                className="inline-flex items-center gap-1 text-[12px] text-[#121B35] font-medium underline underline-offset-2"
              >
                원문 후기 보기
                <i className="ri-external-link-line text-xs" />
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Desktop Detail Panel */}
      {selectedPhoto && (
        <div className="hidden lg:block fixed inset-0 z-50">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/40"
            onClick={closePhoto}
          />

          {/* Right panel */}
          <div className="absolute right-0 top-0 bottom-0 w-[480px] bg-white shadow-2xl overflow-y-auto">
            {/* Panel header */}
            <div className="flex items-center justify-between px-5 h-14 border-b border-[#E8E2DA]">
              <span className="text-[13px] text-[#536079]">{selectedPhoto.label}</span>
              <button
                onClick={closePhoto}
                className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-[#F7F2EA] transition-colors"
              >
                <i className="ri-close-line text-xl text-[#121B35]" />
              </button>
            </div>

            {/* Main image */}
            <div className="w-full aspect-[3/4] bg-[#E8E2DA]">
              <img
                src={selectedPhoto.src}
                alt={selectedPhoto.label}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Related photos */}
            {selectedPhoto.relatedPhotos.length > 0 && (
              <div className="px-5 py-4">
                <p className="text-[11px] font-medium text-[#536079] mb-2">같은 게시글의 사진</p>
                <div className="flex gap-2">
                  {selectedPhoto.relatedPhotos.map((src, i) => (
                    <div key={i} className="w-16 h-16 rounded-lg overflow-hidden bg-[#E8E2DA]">
                      <img src={src} alt="" className="w-full h-full object-cover" />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Info */}
            <div className="px-5 py-4 border-t border-[#E8E2DA]">
              <div className="flex items-center gap-2 mb-3">
                <span className="bg-[#F7F2EA] text-[#121B35] text-[11px] px-2.5 py-1 rounded-full font-medium">
                  {selectedPhoto.category}
                </span>
                <span className="text-[11px] text-[#9AA3B2]">{selectedPhoto.reviewDate}</span>
              </div>

              <h3 className="text-[15px] font-semibold text-[#121B35] mb-1">
                {selectedPhoto.reviewTitle}
              </h3>
              <p className="text-[13px] text-[#536079] leading-[1.7] mb-3">
                {selectedPhoto.description}
              </p>

              <div className="bg-[#F7F2EA] rounded-xl p-4 mb-3">
                <p className="text-[13px] text-[#121B35] leading-[1.7]">
                  {selectedPhoto.reviewSummary}
                </p>
              </div>

              <div className="flex flex-wrap gap-1.5 mb-4">
                {selectedPhoto.keywords.map((kw) => (
                  <span
                    key={kw}
                    className="text-[11px] text-[#536079] bg-white border border-[#E8E2DA] px-2 py-0.5 rounded-full"
                  >
                    {kw}
                  </span>
                ))}
              </div>

              <a
                href={selectedPhoto.originalUrl}
                className="inline-flex items-center gap-1 text-[13px] text-[#121B35] font-medium underline underline-offset-2"
              >
                원문 후기 보기
                <i className="ri-external-link-line text-xs" />
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}